import React, { useCallback, useRef } from 'react';
import { Stack } from '@moda/om';
import { PaymentSource } from '../../../constants';
import { useCart } from '../../../hooks/useCart';
import { CheckoutSection } from '../../CheckoutSection';
import { CheckoutPaymentMethodOptions } from './CheckoutPaymentMethodOptions';
import { CheckoutAffirmPaymentMethod } from './CheckoutAffirmPaymentMethod';
import { CheckoutBraintreePaymentMethod } from './CheckoutBraintreePaymentMethod';

export const CheckoutPaymentMethod: React.FC = () => {
  const {
    cart: {
      attributes: { paymentSource }
    }
  } = useCart();

  const paymentMethodRef = useRef<HTMLDivElement>(null);

  const handleScrollTo = useCallback(() => {
    const element = paymentMethodRef?.current;

    if (element) {
      const { offsetTop } = element;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  }, [paymentMethodRef]);

  return (
    <div ref={paymentMethodRef}>
      <CheckoutSection title="Payment Method">
        <Stack space={4}>
          <CheckoutPaymentMethodOptions />
          {(paymentSource === PaymentSource.Moda || paymentSource === PaymentSource.Braintree) && (
            <CheckoutBraintreePaymentMethod onSaved={handleScrollTo} />
          )}
          {paymentSource === PaymentSource.BraintreeAffirm && <CheckoutAffirmPaymentMethod />}
        </Stack>
      </CheckoutSection>
    </div>
  );
};
